import { ChartModes } from "shared/symbol/constants";

const chartState = {
    tabs: ['EURUSD'],
    selectedTab: 0,
    mode: ChartModes.SINGLE,
}

export default chartState;